<template lang="pug">
  b-select(v-model="discount" @input="onDiscountChange" :placeholder="$t('discounts.select_placeholder')" expanded)
    option(:value="0" v-if="currentDiscount && !discount") {{ $t('discounts.manual_discount') }}
    option(v-else :value="0") {{ $t('discounts.no_discount') }}
    option(v-for="disc in activeDiscounts" :key="disc._id" :value="disc._id") {{disc.name}} {{disc.value}}%
</template>

<script>
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'DiscountSelect',
  props: {
    value: {
      type: String,
      default: undefined
    },
    currentDiscount: {
      type: Number,
      default: undefined
    },
    locationId: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      discount: 0
    }
  },
  computed: {
    ...mapGetters('discounts', ['discountsByLocation', 'discounts']),
    ...mapState('discounts', ['discountsMap']),
    activeDiscounts() {
      let collection
      if (this.locationId) {
        collection = this.discountsByLocation(this.locationId)
      } else {
        collection = this.discounts
      }
      return collection.filter(d => d.active)
    }
  },
  watch: {
    value(val) {
      this.discount = val ? val : 0
    },
    currentDiscount(val) {
      if (val && !this.discount) {
        this.discount = 0
      }
    }
  },
  created() {
    if (this.value) {
      this.discount = this.value
    }
  },
  methods: {
    onDiscountChange(discountId) {
      this.$emit('input', discountId ? this.discountsMap[discountId] : undefined)
    }
  }
}
</script>
